export default __webpack_public_path__ + "static/media/SOLUCIONESGUARDAS1.67e916a8.webp";